import { collection, onSnapshot, Unsubscribe } from "firebase/firestore";
import { Paragraph, Paragraphs } from "types/Paragraph";

export const useDocumentHeaders = (documentId: string, revisionId: string) =>
  defineStore(`/documents/${documentId}/${revisionId}/headers`, () => {
    const allHeaders = ref<Paragraphs>([]);

    const headersSubscription = ref<Unsubscribe | undefined>();

    const isInitialized = ref(false);
    const initialize = async () => {
      if (isInitialized.value) return;

      const db = useFirestore();

      const headersRef = collection(
        db,
        `/documents/${documentId}/revisions/${revisionId}/headers`
      );

      if (headersSubscription.value) {
        headersSubscription.value();
      }

      headersSubscription.value = onSnapshot(headersRef, (snapshot) => {
        allHeaders.value = snapshot.docs.map((doc) => {
          return {
            ...doc.data(),
            id: doc.id,
          } as Paragraph;
        });
      });

      isInitialized.value = true;
    };

    const documentHeaders = computed(() => {
      return allHeaders.value.sort((a, b) => {
        const alignmentOrder: any = { LEFT: 1, CENTER: 2, RIGHT: 3 };
        return (
          alignmentOrder[a.formatting.alignment] -
          alignmentOrder[b.formatting.alignment]
        );
      });
    });

    return {
      initialize,

      documentHeaders,
    };
  });
